<template>
    <div class="top-menu-item">
        <slot>
            <a :href="url" :target="isExternal() ? '_blank' : '_self'">
                <img v-if="icon" :src="icon" width="16" height="16"  /> 
                <span v-else class="no-image"></span>
                {{name}}
            </a>
        </slot>
    </div>
</template>

<script>
export default {
    props: ["name", "icon", "url"],
    components: {
    },
    mounted() {
    },
    methods: {
        isExternal() {
            const url = this.url;
            if (!url) return false;
            return url.indexOf("http") >= 0;
        },
    }
}
</script>

<style lang="scss" scoped>
    .top-menu-item {
        cursor: pointer;
        padding-left: 16px;
        a {
            position: relative;
            text-decoration: none;
            color: #212529;
            font-weight: 600;
            &:hover {
                color: #808080;
            }
            img {
                position: relative;
                bottom: 1px;
            }
        }
        .no-image {
            display: inline-block;
            width: 16px;
            margin-right: 4px;
        }
    }

</style>

<i18n>
{
    en: {
    },
    ru: {
    }
}
</i18n>
